// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"b0-z","sponsoredTooltipWrapper":"c0-z","sponsoredTooltip":"d0-z","newCard":"e0-z"};